<div class="col th-p notification-content-wrapper">
  <header class="top-box-shadow">
    <div class="columns is-gapless is-vcentered is-mobile">
      <div class="is-pulled-left">
        <span class="is-size-6 has-text-weight-semibold">Attendance</span>
      </div>
    </div>
  </header>

  @if (isUserRole==1) {
  <div class="contents is-marginless">
    <div class="scroll-bar">
      <div class="column" style="background-color: #fff">
        <div class="columns">
          <div class="column is-3">
            <div class="field">
              <label class="label has-text-weight-semibold">Lessons</label>
              <div class="select is-fullwidth">
                <select (change)="onSelectedClass($event)">
                  @for (item of groupList; track item; let i = $index) {
                  <option value="{{ item.group_id }}">
                    {{ item.full_name }}
                  </option>
                  }
                </select>
              </div>
            </div>
            <!-- <div class="field">
              <div class="label has-text-weight-semibold">Subject</div>
              <div class="select is-fullwidth">
                <select>
                  <option>5th English</option>
                  <option value="">6th English</option>
                  <option value="">8th English</option>
                </select>
              </div>
            </div> -->
            <div class="field">
              <label class="label">Check In</label>
              <input type="date" class="input" />
            </div>
            <div class="field">
              <label class="label">Check Out</label>
              <input type="date" class="input" />
            </div>
          </div>
          <div class="column is-9">
            <div class="columns">
              <div class="column is-two-fifths">
                <span class="has-text-grey-light"
                  >Date: 09/13/2021 - 09/13/2021</span
                >
              </div>
              <div class="column has-text-grey-light">Lesson: 5th Chaper</div>
              <div class="column">
                <a class="button is-info is-small">
                  <i class="fa fa-download mar-0-10" aria-hidden="true"></i>
                  <span>Download Excel</span>
                </a>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="label">Filter</div>
                <div class="field">
                  <!-- <label class="label has-text-weight-semibold">Student Name</label> -->
                  <div class="select">
                    <select>
                      <option value="" class="is-light">User Name</option>
                      @for (item of userList; track item; let i = $index) {
                      <option value="{{ item.user_id }}">
                        {{ item.first_name }} {{ item.last_name }}
                      </option>
                      }
                    </select>
                  </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <!-- <th>Student Id</th> -->
                      <th>User Name</th>
                      <th>Check In</th>
                      <th>Check Out</th>
                      <th>Total Attan. Hours</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of userList; track item; let i = $index) {
                    <tr>
                      <!-- <td>001</td> -->
                      <td>{{ item.first_name }} {{ item.last_name }}</td>
                      <td>09/13/2021</td>
                      <td>09/13/2021</td>
                      <td>8 Hours</td>
                      <td>
                        <button
                          class="button is-success is-light is-small"
                          style="margin-right: 5px"
                        >
                          <i class="fa fa-check" aria-hidden="true"></i> Present
                        </button>
                        <button
                          class="button is-light is-small"
                          style="margin-right: 5px"
                        >
                          <i class="fa fa-times" aria-hidden="true"></i> Absent
                        </button>
                        <button
                          class="button is-light is-small"
                          style="margin-right: 5px"
                        >
                          <i class="fa fa-clock-o" aria-hidden="true"></i> Late
                        </button>
                        <button class="button is-light is-small">
                          <i class="fa fa-home" aria-hidden="true"></i> Leave
                        </button>
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!--Student Attance-->
  @if (isUserRole!=1) {
  <div class="contents is-marginless">
    <div class="scroll-bar">
      <div class="column" style="background-color: #fff">
        <div class="columns">
          <div class="column is-4">
            <div class="columns new-chat">
              <div class="column">
                <div class="content form-style">
                  <form
                    [formGroup]="newUserForm"
                    (ngSubmit)="addNewUser(newUserForm.value)"
                    novalidate
                  >
                    <div class="columns">
                      <div class="column"></div>
                    </div>
                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label"
                            >Lesson Name
                            <!-- <span class="required">*</span> -->
                          </label>
                          <div class="select">
                            <select name="" id="">
                              <option value="">5th Chapter</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Check In</label>
                          <div class="control">
                            <input class="input" type="date" placeholder="" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column is-6">
                        <div class="field">
                          <label class="label">Check Out</label>
                          <div class="control">
                            <input class="input" type="date" placeholder="" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label"
                            >Status
                            <!-- <span class="required">*</span> -->
                          </label>
                          <div class="select">
                            <select name="" id="">
                              <option value="">Present</option>
                              <option value="">Absent</option>
                              <option value="">Late</option>
                              <option value="">Leave</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field">
                          <label class="label">Notes</label>
                          <div class="control">
                            <textarea
                              class="textarea"
                              placeholder=""
                              formControlName="user_notes"
                              rows="1"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="columns display-flex">
                      <div class="column is-12 has-text-right">
                        <button
                          type="button "
                          [routerLink]="['/attance']"
                          class="button is-right mar-0-10 is-small"
                        >
                          Clear
                        </button>
                        <button
                          type="submit"
                          class="button is-small is-link is-right"
                          [disabled]="!newUserForm.valid"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-8">
            <table class="table">
              <thead>
                <tr>
                  <th>Lesson Name</th>
                  <th>Check In</th>
                  <th>Check Out</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>5th Lesson</td>
                  <td>09/13/2021 09.30</td>
                  <td>09/13/2021 17.30</td>
                  <td>
                    <button
                      class="button is-success is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-check" aria-hidden="true"></i> Present
                    </button>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i> Absent
                    </button>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-clock-o" aria-hidden="true"></i> Late
                    </button>
                    <button class="button is-light is-small">
                      <i class="fa fa-home" aria-hidden="true"></i> Leave
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>5th Lesson</td>
                  <td>09/13/2021 09.30</td>
                  <td>09/13/2021 17.30</td>
                  <td>
                    <button
                      class="button is-success is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-check" aria-hidden="true"></i> Present
                    </button>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i> Absent
                    </button>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-clock-o" aria-hidden="true"></i> Late
                    </button>
                    <button class="button is-light is-small">
                      <i class="fa fa-home" aria-hidden="true"></i> Leave
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>5th Lesson</td>
                  <td>09/13/2021 09.30</td>
                  <td>09/13/2021 17.30</td>
                  <td>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-check" aria-hidden="true"></i> Present
                    </button>
                    <button
                      class="button is-danger is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i> Absent
                    </button>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-clock-o" aria-hidden="true"></i> Late
                    </button>
                    <button class="button is-light is-small">
                      <i class="fa fa-home" aria-hidden="true"></i> Leave
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>5th Lesson</td>
                  <td>09/13/2021 09.30</td>
                  <td>09/13/2021 17.30</td>
                  <td>
                    <button
                      class="button is-success is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-check" aria-hidden="true"></i> Present
                    </button>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i> Absent
                    </button>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-clock-o" aria-hidden="true"></i> Late
                    </button>
                    <button class="button is-light is-small">
                      <i class="fa fa-home" aria-hidden="true"></i> Leave
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>5th Lesson</td>
                  <td>09/13/2021 09.30</td>
                  <td>09/13/2021 17.30</td>
                  <td>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-check" aria-hidden="true"></i> Present
                    </button>
                    <button
                      class="button is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-times" aria-hidden="true"></i> Absent
                    </button>
                    <button
                      class="button is-warning is-light is-small"
                      style="margin-right: 5px"
                    >
                      <i class="fa fa-clock-o" aria-hidden="true"></i> Late
                    </button>
                    <button class="button is-light is-small">
                      <i class="fa fa-home" aria-hidden="true"></i> Leave
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
